import React, { useState, useEffect } from "react";
import {
  FaHome,
  FaBuilding,
  FaUserShield,
  FaUsers,
  FaKey,
  FaLock,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaRobot,
  FaUser,
  FaMoneyBillWave,
  FaGavel,
  FaFileSignature,
  FaEye,
  FaBookOpen,
  FaChartBar,
  FaTrash,
  FaWhatsapp,
  FaHandshake,
  FaInbox,
  FaClipboardCheck,
  FaChartLine,
  FaUserPlus,
  FaProjectDiagram,
  FaFileContract,
  FaBullseye,
  FaUserTie,
  FaHeadset,
  FaMapMarkedAlt,
  FaRegBuilding,
  FaRegFileAlt,
  FaFilm,
  FaCalculator,
  FaEnvelopeOpenText,
  FaSitemap,
  FaFileInvoiceDollar,
  FaCity,
} from "react-icons/fa";
import { db } from "../firebase";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import logo from "../assets/logo.png";

const SidebarSuperAdmin = ({ selected, setSelected, collapsed = false, setCollapsed }) => {
  const [pendingVerification, setPendingVerification] = useState(0);
  const [activeMultas, setActiveMultas] = useState(0);
  const [pendingDeletions, setPendingDeletions] = useState(0);
  const [whatsappNeedsHuman, setWhatsappNeedsHuman] = useState(0);
  const [leadsNeedsHuman, setLeadsNeedsHuman] = useState(0);

  // Listeners Firebase para badges (sin filtro de edificio, ve todo)
  useEffect(() => {
    const qPay = query(
      collection(db, "payments"),
      where("status", "==", "pendiente_verificacion")
    );
    const unsubPay = onSnapshot(qPay, (snap) => {
      setPendingVerification(snap.size);
    }, (err) => console.error("SidebarSuperAdmin payments listener error:", err));

    const qMultas = query(
      collection(db, "multas"),
      where("status", "==", "activa")
    );
    const unsubMultas = onSnapshot(qMultas, (snap) => {
      setActiveMultas(snap.size);
    }, (err) => console.error("SidebarSuperAdmin multas listener error:", err));

    // Solicitudes de baja que esperan al superadmin: pendientes y las que
    // quedaron con error para reintentar (approveBuildingDeletion).
    const qDeletions = query(
      collection(db, "building_deletion_requests"),
      where("status", "in", ["pendiente", "error"])
    );
    const unsubDeletions = onSnapshot(qDeletions, (snap) => {
      setPendingDeletions(snap.size);
    }, (err) => console.error("SidebarSuperAdmin deletions listener error:", err));

    // WhatsApp: conversaciones que necesitan atención humana (escalados de Habi).
    const qWa = query(
      collection(db, "whatsapp_threads"),
      where("needsHuman", "==", true)
    );
    const unsubWa = onSnapshot(qWa, (snap) => {
      setWhatsappNeedsHuman(snap.size);
    }, (err) => console.error("SidebarSuperAdmin whatsapp listener error:", err));

    // Leads: nuevos o que necesitan atención (demos + prospectos).
    const qLeads = query(
      collection(db, "leads"),
      where("needsHuman", "==", true)
    );
    const unsubLeads = onSnapshot(qLeads, (snap) => {
      setLeadsNeedsHuman(snap.size);
    }, (err) => console.error("SidebarSuperAdmin leads listener error:", err));

    return () => { unsubPay(); unsubMultas(); unsubDeletions(); unsubWa(); unsubLeads(); };
  }, []);

  const getBadge = (item) => {
    if (item.badgeKey === "cobranza" && pendingVerification > 0) return pendingVerification;
    if (item.badgeKey === "multas" && activeMultas > 0) return activeMultas;
    if (item.badgeKey === "deletions" && pendingDeletions > 0) return pendingDeletions;
    if (item.badgeKey === "whatsapp" && whatsappNeedsHuman > 0) return whatsappNeedsHuman;
    if (item.badgeKey === "leads" && leadsNeedsHuman > 0) return leadsNeedsHuman;
    return 0;
  };

  const menuSections = [
    {
      title: "GENERAL",
      items: [
        { id: "homesuperadmin", icon: FaHome, label: "Inicio" },
        { id: "edificios", icon: FaBuilding, label: "Edificios" },
      ],
    },
    {
      title: "USUARIOS",
      items: [
        { id: "gestionadmins", icon: FaUserShield, label: "Administradores" },
        { id: "gestioncomerciales", icon: FaUserTie, label: "Comerciales" },
        { id: "gestionusuarios", icon: FaUsers, label: "Residentes" },
      ],
    },
    {
      title: "PERMISOS",
      items: [
        { id: "permisosadmin", icon: FaKey, label: "Permisos Admin" },
        { id: "permisosusuario", icon: FaLock, label: "Permisos Usuario" },
      ],
    },
    {
      title: "FINANZAS",
      items: [
        { id: "cobranzaadmin", icon: FaMoneyBillWave, label: "Cobranza", badgeKey: "cobranza" },
        { id: "multasadmin", icon: FaGavel, label: "Multas", badgeKey: "multas" },
        { id: "estadocuentaedificio", icon: FaChartBar, label: "Estado de Cuenta" },
      ],
    },
    {
      title: "SOLICITUDES",
      items: [
        { id: "solicitudeseliminacion", icon: FaTrash, label: "Eliminaciones", badgeKey: "deletions" },
      ],
    },
    {
      title: "LEADS / VENTAS",
      items: [
        { id: "prospeccion", icon: FaBullseye, label: "Prospección" },
        { id: "mapaprospeccion", icon: FaMapMarkedAlt, label: "Mapa prospección" },
        { id: "seguimientocomercial", icon: FaHeadset, label: "Seguimiento comercial" },
        { id: "desarrolladoras", icon: FaRegBuilding, label: "Desarrolladoras" },
        { id: "administraciones", icon: FaCity, label: "Administraciones" },
        { id: "materiales", icon: FaRegFileAlt, label: "Materiales" },
        { id: "cotizador", icon: FaCalculator, label: "Cotizador" },
        { id: "presupuestoexpress", icon: FaEnvelopeOpenText, label: "Presupuesto exprés" },
        { id: "cotizadorbackoffice", icon: FaFileInvoiceDollar, label: "Cotizador Back office" },
        { id: "leads", icon: FaUserPlus, label: "Leads", badgeKey: "leads" },
      ],
    },
    {
      title: "WHATSAPP",
      items: [
        { id: "whatsappdashboard", icon: FaChartLine, label: "Dashboard" },
        { id: "whatsappinbox", icon: FaInbox, label: "Conversaciones", badgeKey: "whatsapp" },
        { id: "whatsapprevisionbot", icon: FaClipboardCheck, label: "Revisión bot" },
        { id: "whatsapptemplates", icon: FaWhatsapp, label: "Plantillas" },
        { id: "partners", icon: FaHandshake, label: "Partners" },
      ],
    },
    {
      title: "HERRAMIENTAS",
      items: [
        { id: "procesos", icon: FaProjectDiagram, label: "Procesos" },
        { id: "presupuestos", icon: FaFileSignature, label: "Presupuestos" },
        { id: "asambleas", icon: FaHandshake, label: "Asambleas" },
        { id: "actas", icon: FaFileContract, label: "Actas de Asamblea" },
        { id: "reglamento", icon: FaBookOpen, label: "Reglamento Interno" },
        { id: "kbhabitia", icon: FaBookOpen, label: "KB Habitia" },
        { id: "editorreels", icon: FaFilm, label: "Editor de Reels" },
        { id: "equipomarketing", icon: FaSitemap, label: "Equipo de Marketing" },
        { id: "pautamarketing", icon: FaChartLine, label: "Pauta" },
        { id: "habi", icon: FaRobot, label: "Habi" },
        { id: "monitoragentesia", icon: FaRobot, label: "Monitor agentes IA" },
        { id: "vercomoresidente", icon: FaEye, label: "Ver como residente" },
      ],
    },
  ];

  const handleToggle = () => {
    if (setCollapsed) {
      setCollapsed(!collapsed);
    }
  };

  return (
    <aside style={{
      ...styles.sidebar,
      width: collapsed ? 60 : 240,
      minWidth: collapsed ? 60 : 240,
    }}>
      {/* Logo y Toggle */}
      <div style={{
        ...styles.header,
        justifyContent: collapsed ? "center" : "space-between",
        padding: collapsed ? "20px 8px" : "20px 16px",
      }}>
        {!collapsed && (
          <div 
            style={styles.logoContainer}
            onClick={() => setSelected("homesuperadmin")}
          >
            <img
              src={logo}
              alt="Habitia"
              style={{
                ...styles.logo,
                height: 56,
                filter: "brightness(0) invert(1)",
              }}
            />
            {process.env.REACT_APP_FIREBASE_PROJECT_ID === "habitia-dev-8b512" && (
              <span style={{
                display: "block",
                fontSize: 9,
                fontWeight: 700,
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                color: "rgba(255,255,255,0.6)",
                marginTop: 2,
                lineHeight: 1,
              }}>Testing</span>
            )}
          </div>
        )}
        <button
          style={styles.toggleBtn}
          onClick={handleToggle}
          title={collapsed ? "Expandir" : "Minimizar"}
        >
          {collapsed ? (
            <FaAngleDoubleRight size={14} color="#ffffff" />
          ) : (
            <FaAngleDoubleLeft size={14} color="#ffffff" />
          )}
        </button>
      </div>

      {/* Menú agrupado */}
      <nav style={styles.nav}>
        {menuSections.map((section, sectionIndex) => (
          <div key={section.title} style={styles.section}>
            {/* Título de sección */}
            {!collapsed && (
              <div style={styles.sectionTitle}>{section.title}</div>
            )}
            {collapsed && sectionIndex > 0 && (
              <div style={styles.sectionDivider}></div>
            )}
            
            {/* Items de la sección */}
            {section.items.map((item) => {
              const isActive = selected === item.id;
              const badge = getBadge(item);
              return (
                <div
                  key={item.id}
                  style={{
                    ...styles.menuItem,
                    ...(isActive ? styles.menuItemActive : {}),
                    justifyContent: collapsed ? "center" : "flex-start",
                    padding: collapsed ? "12px" : "10px 16px",
                  }}
                  onClick={() => setSelected(item.id)}
                  onMouseEnter={(e) => {
                    if (!isActive) {
                      e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.08)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isActive) {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }
                  }}
                  title={collapsed ? item.label : ""}
                >
                  <item.icon
                    size={18}
                    color={isActive ? "#ffffff" : "rgba(255, 255, 255, 0.7)"}
                    style={{ flexShrink: 0 }}
                  />
                  {!collapsed && (
                    <span style={{
                      ...styles.menuLabel,
                      color: "#ffffff",
                      fontWeight: 400,
                    }}>
                      {item.label}
                    </span>
                  )}
                  {badge > 0 && (
                    <span style={{
                      ...styles.badge,
                      ...(collapsed ? styles.badgeCollapsed : {}),
                    }}>
                      {badge > 99 ? "99+" : badge}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </nav>
    </aside>
  );
};

const styles = {
  sidebar: {
    position: "fixed",
    left: 0,
    top: 0,
    bottom: 0,
    backgroundColor: "#000000",
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    minHeight: "100vh",
    flexShrink: 0,
    transition: "width 0.2s ease, min-width 0.2s ease",
    overflow: "hidden",
    fontFamily: "'FT Habit', -apple-system, BlinkMacSystemFont, sans-serif",
    zIndex: 100,
  },
  header: {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    flex: 1,
  },
  logo: {
    width: "auto",
    objectFit: "contain",
  },
  toggleBtn: {
    width: 32,
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    transition: "all 0.15s ease",
    flexShrink: 0,
  },
  nav: {
    flex: 1,
    overflowY: "auto",
    padding: "12px 8px",
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  section: {
    marginBottom: 8,
  },
  sectionTitle: {
    fontSize: 11,
    fontWeight: 400,
    color: "rgba(255, 255, 255, 0.4)",
    letterSpacing: "0.5px",
    padding: "8px 16px 6px",
    textTransform: "uppercase",
  },
  sectionDivider: {
    height: 1,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    margin: "8px 12px",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "10px 16px",
    borderRadius: 8,
    cursor: "pointer",
    transition: "all 0.15s ease",
    position: "relative",
  },
  menuItemActive: {
    backgroundColor: "#0080ff",
  },
  menuLabel: {
    fontSize: 14,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    flex: 1,
  },
  badge: {
    backgroundColor: "#ef4444",
    color: "#ffffff",
    fontSize: 10,
    fontWeight: 400,
    borderRadius: 10,
    padding: "1px 6px",
    minWidth: 18,
    textAlign: "center",
    lineHeight: "16px",
    flexShrink: 0,
  },
  badgeCollapsed: {
    position: "absolute",
    top: 2,
    right: 2,
    fontSize: 9,
    padding: "0px 4px",
    minWidth: 14,
    lineHeight: "14px",
  },
};

export default SidebarSuperAdmin;
